module.exports = __webpack_public_path__ + "static/media/hero-datos-abiertos.678466c7.png";